{
	"analystsForecast": {
		"strongBuy": "Strong Buy",
		"buy": "Buy",
		"neutral": "Neutral",
		"sell": "Sell",
		"strongSell": "Strong Sell",
		"countAnalysts": "Based on stock ratings for {{symbol}} from {{count}} analysts.",
		"conclusion": "Analysts forecast"
	}
}
